import { APP_ROUTE_PATHS } from "../appRoutePaths";

export const GLOBAL_NAV_ITEMS = [
  {
    id: "dashboard",
    label: "Dashboard",
    to: APP_ROUTE_PATHS.home,
    icon: "dashboard",
    match: [APP_ROUTE_PATHS.home, APP_ROUTE_PATHS.dashboard],
  },
  {
    id: "projectManagement",
    label: "Project Management",
    officialName: "Project Management Suite",
    to: APP_ROUTE_PATHS.projectManagement,
    icon: "project",
  },
  {
    id: "calculationsSuite",
    label: "Calculations Suite",
    to: APP_ROUTE_PATHS.calculationsSuite,
    icon: "calculator",
  },
  {
    id: "aiAssistant",
    label: "AI Assistant",
    to: APP_ROUTE_PATHS.aiAssistant,
    icon: "ai",
    match: [APP_ROUTE_PATHS.aiAssistant],
  },
];

export const GLOBAL_RESOURCE_LINKS = [
  { id: "formulaReference", label: "Formula Reference", to: APP_ROUTE_PATHS.formulaReference, icon: "reference" },
  { id: "materialData", label: "Material Data", to: APP_ROUTE_PATHS.materialData, icon: "material" },
  { id: "resources", label: "Resources", to: APP_ROUTE_PATHS.resources, icon: "resources" },
  { id: "whatsNew", label: "What's New", to: APP_ROUTE_PATHS.whatsNew, icon: "spark" },
  { id: "about", label: "About ManuCalc", to: APP_ROUTE_PATHS.about, icon: "info" },
];

export const PROJECT_SUITE_NAV_GROUPS = [
  {
    id: "overview",
    label: "Overview",
    items: [
      { id: "suiteOverview", label: "Suite Overview", to: APP_ROUTE_PATHS.projectManagement, icon: "project" },
      { id: "projectWorkspace", label: "Company Projects", to: APP_ROUTE_PATHS.workspace, icon: "grid", businessOnly: true },
      { id: "projectBoards", label: "Legacy Board", to: APP_ROUTE_PATHS.projectBoards, icon: "grid", personalOnly: true },
      { id: "workspace", label: "Workspace", to: APP_ROUTE_PATHS.workspace, icon: "workspace", requiresJobs: true },
      { id: "personalProjects", label: "Personal Projects", to: APP_ROUTE_PATHS.personalProjects, icon: "folder", personalOnly: true },
      { id: "collaborativeProjects", label: "Company Projects", to: APP_ROUTE_PATHS.collaborativeProjects, icon: "team", businessOnly: true },
    ],
  },
  {
    id: "planning",
    label: "Planning",
    items: [
      { id: "manufacturingPlans", label: "Manufacturing Plans", to: APP_ROUTE_PATHS.jobs, icon: "clipboard", requiresJobs: true, startsWith: [APP_ROUTE_PATHS.jobs, "/saved-jobs"] },
      { id: "quoteAnalyses", label: "Quote Analyses", to: APP_ROUTE_PATHS.quoteAnalyses, icon: "quote", requiresJobs: true },
      { id: "drawingReviews", label: "Drawing Reviews", to: APP_ROUTE_PATHS.drawingReviews, icon: "drawing", requiresJobs: true },
      { id: "capacityPlanner", label: "Capacity Planner", to: APP_ROUTE_PATHS.capacityPlanner, icon: "capacity", requiresJobs: true },
    ],
  },
  {
    id: "documentation",
    label: "Documentation",
    items: [
      { id: "sopBuilder", label: "SOP Builder", to: APP_ROUTE_PATHS.processBuilder, icon: "document", requiresJobs: true },
      { id: "setupSheets", label: "Setup Sheets", to: APP_ROUTE_PATHS.setupSheets, icon: "wrench", requiresJobs: true },
      { id: "jobTravelers", label: "Job Travelers", to: APP_ROUTE_PATHS.jobTravelers, icon: "route", requiresJobs: true },
      { id: "inspection", label: "Inspection Sheets", to: APP_ROUTE_PATHS.inspection, icon: "check", requiresJobs: true },
      { id: "firstArticle", label: "First Articles", to: APP_ROUTE_PATHS.firstArticleInspections, icon: "check", requiresJobs: true },
      { id: "controlPlans", label: "Control Plans", to: APP_ROUTE_PATHS.controlPlans, icon: "check", requiresJobs: true },
    ],
  },
  {
    id: "operations",
    label: "Operations",
    items: [
      { id: "files", label: "File Center", to: APP_ROUTE_PATHS.files, icon: "folder", requiresJobs: true },
      { id: "tools", label: "Tool Library", to: APP_ROUTE_PATHS.tools, icon: "tool", requiresJobs: true },
      { id: "fixtures", label: "Fixture Library", to: APP_ROUTE_PATHS.fixtures, icon: "fixture", requiresJobs: true },
      { id: "machines", label: "Machine Database", to: APP_ROUTE_PATHS.machines, icon: "machine", requiresJobs: true },
      { id: "shopBrain", label: "Shop Brain", to: APP_ROUTE_PATHS.shopBrain, icon: "brain", requiresJobs: true },
      { id: "shopFloor", label: "Shop Floor Mode", to: APP_ROUTE_PATHS.shopFloor, icon: "shop", requiresJobs: true },
      { id: "threeS", label: "3S Workspace", to: APP_ROUTE_PATHS.threeS, icon: "layers" },
      { id: "exports", label: "Export Center", to: APP_ROUTE_PATHS.exports, icon: "download", requiresExport: true },
      { id: "qrCodes", label: "QR Code Center", to: APP_ROUTE_PATHS.qrCodes, icon: "qr", requiresJobs: true },
    ],
  },
  {
    id: "collaboration",
    label: "Collaboration",
    items: [
      { id: "messages", label: "Company Messages", to: APP_ROUTE_PATHS.messages, icon: "messages", companyOnly: true },
      { id: "notifications", label: "Notifications", to: APP_ROUTE_PATHS.notifications, icon: "bell" },
    ],
  },
];

export const CALCULATIONS_SUITE_NAV_GROUPS = [
  {
    id: "calculations",
    label: "Calculations",
    items: [
      { id: "calcOverview", label: "Suite Overview", to: APP_ROUTE_PATHS.calculationsSuite, icon: "calculator" },
      { id: "allCalculators", label: "All Calculators", to: `${APP_ROUTE_PATHS.calculationsSuite}#calculator-library`, icon: "grid" },
      { id: "pinnedCalculators", label: "Pinned Calculators", to: `${APP_ROUTE_PATHS.calculationsSuite}#pinned-calculators`, icon: "pin" },
      { id: "recentCalculators", label: "Recently Used", to: `${APP_ROUTE_PATHS.calculationsSuite}#recent-tools`, icon: "history" },
      { id: "savedCalculations", label: "Saved Calculations", to: APP_ROUTE_PATHS.calculationsSuite, icon: "save" },
    ],
  },
  {
    id: "references",
    label: "References",
    items: [
      { id: "formulaReference", label: "Formula Reference", to: APP_ROUTE_PATHS.formulaReference, icon: "reference" },
      { id: "materialData", label: "Material Data", to: APP_ROUTE_PATHS.materialData, icon: "material" },
    ],
  },
];

export const ADMIN_NAV_ITEMS = [
  { id: "adminDashboard", label: "Admin Dashboard", to: APP_ROUTE_PATHS.admin, icon: "shield", companyAdmin: true },
  {
    id: "ownerRequests",
    label: "Owner Request Board",
    to: APP_ROUTE_PATHS.ownerRequests,
    icon: "shield",
    platformOwner: true,
    match: [APP_ROUTE_PATHS.ownerRequests, APP_ROUTE_PATHS.platformFeatureRequests],
  },
  { id: "systemHealth", label: "System Health", to: APP_ROUTE_PATHS.systemHealth, icon: "health", platformOwner: true },
  { id: "productAnalytics", label: "Product Analytics", to: APP_ROUTE_PATHS.productAnalytics, icon: "chart", platformOwner: true },
];

export const pathStartsWith = (path = "", route = "") =>
  route && (path === route || path.startsWith(`${route}/`));

export const matchesNavItem = (path = "", item = {}) => {
  const routes = item.startsWith || item.match || [item.to];
  return routes.some((route) => pathStartsWith(path, route));
};

export const PROJECT_SUITE_ROUTE_PREFIXES = PROJECT_SUITE_NAV_GROUPS
  .flatMap((group) => group.items.flatMap((item) => item.startsWith || [item.to]))
  .concat([APP_ROUTE_PATHS.projectManagement, APP_ROUTE_PATHS.companyProject.replace("/:projectId", "")]);

export const CALCULATIONS_SUITE_ROUTE_PREFIXES = [
  APP_ROUTE_PATHS.calculationsSuite,
  "/calculator",
];

export const isProjectSuiteRoute = (path = "") =>
  PROJECT_SUITE_ROUTE_PREFIXES.some((route) => pathStartsWith(path, route));

export const isCalculationsSuiteRoute = (path = "") =>
  CALCULATIONS_SUITE_ROUTE_PREFIXES.some((route) => pathStartsWith(path, route));

export const filterSuiteGroups = (
  groups,
  { isBusiness = false, canAccessJobs = true, canExport = false, hasCompany = false } = {}
) =>
  groups
    .map((group) => ({
      ...group,
      items: group.items.filter((item) => {
        if (item.businessOnly && !isBusiness) return false;
        if (item.personalOnly && isBusiness) return false;
        if (item.requiresJobs && !canAccessJobs) return false;
        if (item.requiresExport && !canExport) return false;
        if (item.companyOnly && !hasCompany) return false;
        return true;
      }),
    }))
    .filter((group) => group.items.length > 0);
